import React from 'react';

import Input from './../Input';

const Tel = (props) => (
    <Input label="联系电话" name="tel" {...props}></Input>
);

export default Tel;